import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Paragraph from '../styleguide/Paragraph'

const styles = theme => ({
  messageStyle: {
    color: '#e40045'
  }
})

const ErrorMessage = ({ message, classes: { messageStyle } }) => (
  <Paragraph className={messageStyle}>{message}</Paragraph>
)

export default withStyles(styles)(ErrorMessage)



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js